import { checkTokenError, getAuthHeaders } from "../utils/auth";

export const Get = async (url, retryCount = 0) => {
    try {
        const response = await fetch(url, {
            headers: getAuthHeaders(),
        });

        const responseData = await response.json();

        if (response.status !== 200) {
            const errorData = responseData;
            errorData.status = response.status;
            throw errorData;
        }

        return responseData;
    } catch (error) {
        return await checkTokenError(error, retryCount, () => Get(url, 1));
    }
};

export const Post = async (url, data, retryCount = 0) => {
    const isFormData = data instanceof FormData;
    const headers = getAuthHeaders();

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        data = JSON.stringify(data);
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: data,
        });

        if (!response.ok) {
            const errorData = await response.json();
            errorData.status = response.status;
            throw errorData;
        }

        return response.json();
    } catch (error) {
        return await checkTokenError(error, retryCount, () => Post(url, data, 1));
    }
};

export const Patch = async (url, data, retryCount = 0) => {
    const isFormData = data instanceof FormData;
    const headers = getAuthHeaders();

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        data = JSON.stringify(data);
    }

    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers: headers,
            body: data,
        });

        if (!response.ok) {
            const errorData = await response.json();
            errorData.status = response.status;
            throw errorData;
        }

        return response.json();
    } catch (error) {
        return await checkTokenError(error, retryCount, () => Patch(url, data, 1));
    }
};

export const Put = async (url, data, retryCount = 0) => {
    const isFormData = data instanceof FormData;
    const headers = getAuthHeaders();

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
        data = JSON.stringify(data);
    }

    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: headers,
            body: data,
        });

        if (!response.ok) {
            const errorData = await response.json();
            errorData.status = response.status;
            throw errorData;
        }

        return response.json();
    } catch (error) {
        return await checkTokenError(error, retryCount, () => Put(url, data, 1));
    }
};

export const Download = async (url, data, retryCount = 0) => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...getAuthHeaders(),
                ['Content-Type']: 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (response.status !== 200) {
            const errorData = await response.json();
            errorData.status = response.status;
            throw errorData;
        }

        return await response.blob();
    } catch (error) {
        return await checkTokenError(error, retryCount, () => Download(url, data, 1));
    }
};

export const Delete = async (url, data, retryCount = 0) => {
    const queryString = new URLSearchParams(data).toString();
    const fullUrl = `${url}?${queryString}`;

    try {
        const response = await fetch(fullUrl, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        const responseData = await response.json();

        if (response.status !== 200) {
            const errorData = responseData;
            errorData.status = response.status;
            throw errorData;
        }

        return responseData;
    } catch (error) {
        return await checkTokenError(error, retryCount, () => Delete(url, data, 1));
    }
};
